import UserAuth from '@services/auth';
import ReactGA from 'react-ga4';
import { getPageName } from './common';
import { StorageKeys } from '@constants/common';

export const initGA = () => {
  const gaKey = process.env.REACT_APP_GA_KEY;

  ReactGA.initialize(gaKey!);
};

export const sendGAData = (eventName: string, eventProperties: any = {}) => {
  const userDetails = UserAuth.userDetails;

  // Send GA4 Event
  ReactGA.event(eventName, {
    'Page Name': eventProperties['Page Name']
      ? eventProperties['Page Name']
      : getPageName(),
    Navigation: eventProperties['Navigation']
      ? eventProperties['Navigation']
      : getPageName(
          window.localStorage.getItem(StorageKeys.PREVIOUS_URL) || ''
        ),
    'User ID': userDetails?.user.id,
    Industry: userDetails?.industry,
    Role: userDetails?.role,
    Company: userDetails?.company_name,
    ...eventProperties
  });
};
